import axios from "axios";

const apiClient = axios.create({
  // baseURL: "http://localhost:1337/api",
  baseURL: "https://ams-prod.matchandmake.de/api",
});

export default apiClient;
